import React from "react";
import PropTypes from "prop-types";
import { Form, Button } from "antd";
import cx from "classnames";
import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import {
    INPUT_TYPES
} from "constants/index";
import CompanyService from "services/company-service";
import BankAccountService from "./../services";
import { BANK_ACCOUNT_TYPES } from "constants/enums";
import "styles/form.css";

const FORM_FIELDS = new OrderedMap({
    company: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "Company Name",
        showSearch: true,
        labelProp: "name",
        onSearch: (str) => CompanyService.getCompanyProfiles(null, str),
        formatData: (data) => {
            if(data) {
                return data.map(_ => {
                    return {
                        ..._,
                        name: `${_.name}(${_.gstin})`
                    };
                });
            }
            return data;
        },
        // rules: [
        //     {
        //         required: true,
        //         messsage: "Required"
        //     }
        // ],
    },
    lending_partner: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Partner Bank",
        rules: [],
        options: [],
    },
    partner_bank_account: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "Partner Bank Account",
        rules: [],
        labelProp: "account_number",
        formatData: (data) => {
            if(data) {
                return data.map(_ => {
                    return {
                        ..._,
                        account_number: `${_.account_number}(${(_.bank_branch && _.bank_branch.ifsc_code) || "--"})`
                    };
                });
            }
            return data;
        },
        options: [],
    },
    account_holder_name: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Account Holder Name",
        rules: [
            {
                required: true,
                messsage: "Required"
            }
        ],
    },
    account_number: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Account Number",
        rules: [
            {
                required: true,
                messsage: "Required"
            },
        ],
    },
    account_type: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Account Type",
        rules: [
            {
                required: true,
                messsage: "Required"
            },
        ],
        options: BANK_ACCOUNT_TYPES.map((value, label) => ({
            value: String(value),
            label
        })).toList(),
    },
    ifsc_code: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "IFSC Code",
        showSearch: true,
        labelProp: "ifsc_code",
        // rules: [
        //     {
        //         required: true,
        //         messsage: "Required"
        //     },
        // ],
        options: [],
    },
    bank_branch: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.OBJECT_TEXT,
        label: "Bank Branch",
        // rules: [
        //     {
        //         required: true,
        //         messsage: "Required"
        //     },
        // ],
    },
    is_key_account: {
        className: "form-field fb-30 w-30 mr-3perc",
        type: INPUT_TYPES.RADIO,
        label: "Is Key Account",
        rules: [
            {
                required: true,
                message: "Required"
            }
        ],
        options: [{label: "Yes", value: true}, {label: "No", value: false}]
    }
});

class AddBankAccount extends React.Component {

    state = {
        partner_bank_account: []
    };

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onValuesSubmit({...values, id: this.props.bankDetails && this.props.bankDetails.id});
            }
        });
    };

    formatData = (data) => {
        if(data) {
            return data.map(_ => {
                return {
                    ..._,
                    name: `${_.name} (${_.gstin})`
                };
            });
        }
        return data;
    }

    ifscLookup = str =>
        CompanyService.ifscLookup(str).then(({ data }) => ({
            data: data.results
        }));
    getValueFromObject = bankBranch => {
        if (!bankBranch) {
            return null;
        }
        return bankBranch.name;
    };
    setBankBranchName = branch => {
        this.props.form.setFieldsValue({
            bank_branch: branch
        });
    };
    enhanceFormFields = () => {
        let lendingPartner = this.props.form.getFieldValue("lending_partner");
        return FORM_FIELDS.setIn(["ifsc_code", "onSearch"], this.ifscLookup)
            .setIn(["ifsc_code", "onSelect"], this.setBankBranchName)
            .setIn(
                ["bank_branch", "getValueFromObject"],
                this.getValueFromObject
            )
            .setIn(
                ["lending_partner", "options"],
                this.props.lending_partners ? this.props.lending_partners.map(_ => ({
                    label: _.name,
                    value: _.id
                })) : []
            )
            .setIn(
                ["partner_bank_account", "getOptionsOnFocus"],
                BankAccountService.getPartnerBankAccountList.bind(null, lendingPartner)
            );
    }

    render() {
        this.fields = this.enhanceFormFields();
        return (
            <Form layout={"horizontal"} onSubmit={this.onValuesSubmit} className={cx("form", "br-3")}>
                <div className={"form-row"}>
                    {this.fields.map((field, fieldName) => {
                        return this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )();
                    }).toList()}
                </div>
                <div className={"mt-10 p-5 d-flex justify-content-flex-end"}>
                    <Button type={"primary"} htmlType="submit" className={"mr-5"}>
                        {!this.props.bankDetails ? "Create Account" : "Update Account"}
                    </Button>
                    <Button onClick={this.props.closeModal}>
                        {"Cancel"}
                    </Button>
                </div>
            </Form>
        );
    }
}

AddBankAccount.propTypes = {
    closeModal: PropTypes.func,
    form: PropTypes.object,
    bankDetails: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    lending_partners: PropTypes.func
};

AddBankAccount.defaultProps = {
    salesManagers: [],
    disableFields: false
};

export default Form.create({
    mapPropsToFields: ({ bankDetails }) => {
        return (
            bankDetails &&
            bankDetails
                .toSeq()
                .toMap()
                .map(value => {
                    return Form.createFormField({
                        value
                    });
                })
                .set(
                    "lending_partner",
                    Form.createFormField({
                        value: bankDetails.partner_bank_account && 
                        bankDetails.partner_bank_account.partner_bank && 
                        bankDetails.partner_bank_account.partner_bank.id
                    })
                )
                .set(
                    "account_type",
                    Form.createFormField({
                        value: String(bankDetails.account_type)
                    })
                )
                .set(
                    "ifsc_code",
                    Form.createFormField({
                        value: bankDetails.bank_branch
                    })
                )
                .toJS()
        );
    }
})(AddBankAccount);
